export default __webpack_public_path__ + "static/media/laptop-basics.90d9570c.png";